import React, {Component} from 'react'
import './styles.css'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import Skeleton from '../../components/skeleton'
import {Link, useHistory, Redirect} from 'react-router-dom'
import {connect} from 'react-redux'
import {PRECISA_LOGAR, NOME_EMPRESA} from '../../config'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faCoffee, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import {confirmAlert} from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'

const estadoInicial = {
    name: '',
    seaports: [],
    loading: false,
    redirect: false
}

class Seaports extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = () => {
   
    }

    erroApi = async () => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    deleteSeaport = async (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className='custom-ui text-center'>
                  <h1>{NOME_EMPRESA}</h1>
                  <p>Deseja remover este Seaport?({nome})</p>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-success w-25"
                      onClick={
                          async () => {
                              onClose()
                          }
                      }
                  >
                      Não
                  </button>
                  <button 
                      style={{marginRight: 5}}
                      className="btn btn-danger w-25"
                      onClick= {
                            async () => {
                                await apiEmployee.post(`deleteSeaport.php`, {
                                    token: this.props.token,
                                    id_seaport: id
                                }).then(
                                    async response => { 
                                        if(response.data == true){
                                            alert('Porto removido!')
                                            document.location.reload()
                                        }
                                    },
                                    async response => {
                                        this.erroApi(response)
                                    }
                                )
                                onClose()
                            }    
                        }
                           
                    >
                      Sim
                  </button>
                </div>
              )
            }
        })
    }

    render(){
        
        return (

            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }

                {!this.state.loading &&
                <div>
                <section>
                    <Header voltar/>
                    
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="page-breadcrumb">
                                    <h2 id='titulo'>Relatorio</h2>
                                </div>
                            </div>
                        </div>
                    
                </section>

                <div className="row deixarnocentro">
                   <div className="col-8 row cntrelatorio">
                       
                    </div>                        
                </div>
                    
            



               </div>
            }
            </div>
        )
        
    }
}

const mapStateToProps = ({user, servidor}) => {
    return{
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Seaports)